import { Box, Button, Container, Typography } from "@mui/material";
import Datumizo from "Components/LabIZO/Datumizo";
import { Authority, ColorX } from "static";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { HStack, VStack } from "Components/Layouts";
import { IDefaultProps } from "./defaultProps";
import IScatterBoard from "./DocChart";
import { CusAuth } from "interfaces";

enum View {
  Table = "Table",
  "3D" = "3D",
}

interface ViewSelectorProps {
  view: View;
  setView: any;
  reqAuth?: string;
}

const view2AuthorityMap: Record<View, CusAuth | null> = {
  [View["3D"]]: CusAuth["3DView"],
  [View.Table]: null,
};

const ViewSelector: React.FC<ViewSelectorProps> = ({ view, setView, reqAuth }) => {
  const viewButtons: JSX.Element[] = [];

  Object.values(View).forEach((v) => {
    if (!reqAuth || v === View.Table || Authority.IsAccessibleQ(reqAuth, undefined, view2AuthorityMap[v]!)) {
      viewButtons.push(
        <Button key={v} variant={view === v ? "contained" : "outlined"} onClick={() => setView(v)}>
          {`${v} View`}
        </Button>
      );
    }
  });

  return viewButtons.length > 1 ? <>{viewButtons}</> : <></>;
};

const DocumentManager: React.FC<IDefaultProps> = (props) => {
  const { title, base } = props;
  const [MountDatumizo, setMountDatumizo] = useState<any>(false);
  const [data, setData] = useState<any>(false);
  const [view, setView] = useState<View>(View.Table);

  function onMountDatumizo(callback: any) {
    setMountDatumizo(callback);
  }

  async function onQuitInner() {
    await MountDatumizo?.Reload(true);
  }

  return (
    <VStack height="100%" justifyContent="flex-start">
      <Box padding={1} width="100%">
        <Typography
          style={{
            textAlign: "left",
            width: "100%",
            fontSize: 25,
            color: ColorX.GetColorCSS("Primary"),
          }}
        >
          {title}
        </Typography>
      </Box>

      <Datumizo
        //
        base={base}
        addOns={{ workspace: "master", data }}
        languageSelector={false}
        onMounted={onMountDatumizo}
        onQuitInner={onQuitInner}
        serverSidePagination={false}
        //onLoad={this._SetAllAutoSoft Reload}
        noDefaultTable={view === "3D"}
        injectRightButtons={<ViewSelector view={view} setView={setView} reqAuth={base?.reqAuth} />}
      >
        {/* 3D View */}
        {view == "3D" && !process.env.REACT_APP_CUSTOM_EMBEDDING_PROJECTOR_URL ? <IScatterBoard /> : <></>}
        {view === "3D" && process.env.REACT_APP_CUSTOM_EMBEDDING_PROJECTOR_URL ? (
          <HStack
            id="visualisation-service-container"
            sx={{
              pt: 6,
              position: "absolute",
              height: "90vh",
            }}
          >
            <iframe
              style={{
                border: "none",
                height: "100%",
                width: "100%",
              }}
              src={process.env.REACT_APP_CUSTOM_EMBEDDING_PROJECTOR_URL}
              width="100%"
              height="100%"
            />
          </HStack>
        ) : (
          <></>
        )}
      </Datumizo>
    </VStack>
  );
};

export default observer(DocumentManager);
